export const TEXTS = {
  MEASUREMENT_FOR: (name = '') => `Measurements for ${name}`,
  SELECT_SIZE: 'Select Size',
  SIZE_GUIDE: 'Size Guide',
};

export const TRACKING_KEY = 'sizeGuideClick:selectSize';
export const SIZE_GUIDE_INTERACTION_LOCATION = 'productDetailPage:sizeGuide';
export const SOLD_OUT_LEGEND = 'Sold out';
export const FEW_LEFT_LEGEND = 'Few left';
export const WIDTH_OFFSET = 8;
export const SIZE_SECTION_V2_CONFIG = 'pdpSizeSectionV2Enabled';
export const SIZE_GUIDE_SELECTION_MWEB_EXPERIMENT = 'size-guide-selection-mweb';
export const SIZE_GUIDE_SELECTION_DWEB_EXPERIMENT = 'size-guide-selection-dweb';
export const SIZE_GUIDE_SELECTION_APP_ANDROID_EXPERIMENT = 'size-guide-selection-app-android';
export const SIZE_GUIDE_SELECTION_APP_IOS_EXPERIMENT = 'size-guide-selection-app-ios';
export const SIZE_GUIDE_SELECTION_MWEB_VARIANT = 'size-guide-selection-mweb-a';
export const SIZE_GUIDE_SELECTION_DWEB_VARIANT = 'size-guide-selection-dweb-a';
export const SIZE_GUIDE_SELECTION_APP_ANDROID_VARIANT = 'size-guide-selection-app-android-a';
export const SIZE_GUIDE_SELECTION_APP_IOS_VARIANT = 'size-guide-selection-app-ios-a';
export const WINDOW_SCROLL_OFFSET = 140;
export const SCROLL_DELAY = 100;
